const isInteger = (value) => {
  const intRegex = /^[0-9]\d*$/;
  return intRegex.test(value);
};

export default isInteger;
